<template>
    <div id="app">
        <div class="shop-header-margin shop-header-element-ui-less" :class="'shop-header-element-ui-less-'+data_info.nav_color">
            <div class="top-one">
                <head_dianpu></head_dianpu>
            </div>
            <div class="top-two hidden-sm-and-down">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                        <div>
                            <el-row :gutter="20">
                                <el-col :xs="14" :sm="9" :md="9" :lg="7" :xl="7">
                                    <img src="../../../assets/home/logo.png" style="width: 100%;height: 100%"/>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                                    <div class="top-two_text">
                                        <span style="float: left">{{data_info.shop_name}}</span>
                                        <div class="follow" style="color: #c60000;border: 1px solid #c60000;">
                                            <span v-if="data_info.auth_info.type==1">个人</span>
                                            <span v-if="data_info.auth_info.type==2">企业</span>
                                            <span v-if="data_info.auth_info.type==3">企业</span>
                                        </div>
                                        <div class="follow" :class="data_info.nav_color+'_follow'" @click="shouce1()">
                                            {{xiontai}}
                                        </div>
                                    </div>
                                    <div class="label">技能标签：
                                        <el-tag type="info" style="margin-right: 5px;" size="mini"
                                                v-for="(item,index) in data_info.skill" :key="index">{{ item.tag_value}}
                                        </el-tag>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="20" :md="9" :lg="9" :xl="9">
                        <div>
                            <el-input size="small " placeholder="请输入内容" v-model="input3" class="input-with-select">
                                <el-select class="xujz" v-model="select" slot="prepend" placeholder="请选择">
                                    <el-option v-if="data_info.auth_info.type!==1" label="在线商品" value=""></el-option>
                                    <el-option label="在线服务" value="#/shops/service/"></el-option>
                                    <el-option label="成功案例" value="#/shops/case/"></el-option>
                                    <el-option label="仪才秀" value="#/shops/video/"></el-option>
                                    <el-option label="小星点灯" value="#/shops/light/"></el-option>
                                    <el-option label="应用方案" value="#/shops/programme/"></el-option>
                                    <el-option label="行业标准" value="#/shops/standard/"></el-option>
                                </el-select>
                                <el-button slot="append" @click="shijian">搜索</el-button>
                            </el-input>
                        </div>
                    </el-col>

                </el-row>
            </div>
            <div class="top-three hidden-sm-and-down" :class="data_info.nav_color" >
                <div class="hidden-sm-and-down three_pc">
                    <a :href="'#/shops/index/'+shop_id">
                        <div class="kuai "
                             :class="$route.path==='/shops/index/'+shop_id?data_info.nav_color+'_new':''">首页
                        </div>
                    </a>
                    <a :href="'#/shops/commodity/'+shop_id" v-if="data_info.auth_info.type!==1">
                        <div class="kuai"
                             :class="$route.path=='/shops/commodity/'+shop_id?data_info.nav_color+'_new':''">
                            在线商品
                        </div>
                    </a>
                    <a :href="'#/shops/service/'+shop_id">
                        <div class="kuai"
                             :class="$route.path=='/shops/service/'+shop_id?data_info.nav_color+'_new':''">在线服务
                        </div>
                    </a>
                    <a :href="'#/shops/case/'+shop_id">
                        <div class="kuai"
                             :class="$route.path=='/shops/case/'+shop_id?data_info.nav_color+'_new':''">成功案例
                        </div>
                    </a>
                    <a :href="'#/shops/video/'+shop_id">
                        <div class="kuai1"
                             :class="$route.path=='/shops/video/'+shop_id?data_info.nav_color+'_new':''">仪才秀
                        </div>
                    </a>
                    <a :href="'#/shops/light/'+shop_id">
                        <div class="kuai"
                             :class="$route.path=='/shops/light/'+shop_id?data_info.nav_color+'_new':''">小星点灯
                        </div>
                    </a>
                    <a :href="'#/shops/programme/'+shop_id">
                        <div class="kuai"
                             :class="$route.path=='/shops/programme/'+shop_id?data_info.nav_color+'_new':''">应用方案
                        </div>
                    </a>
                    <a :href="'#/shops/standard/'+shop_id">
                        <div class="kuai"
                             :class="$route.path=='/shops/standard/'+shop_id?data_info.nav_color+'_new':''">行业标准
                        </div>
                    </a>
                    <a :href="'#/shops/companyData/'+shop_id">
                        <div class="kuai"
                             :class="$route.path=='/shops/companyData/'+shop_id?data_info.nav_color+'_new':''">公司资料
                        </div>
                    </a>
                </div>
            </div>
            <div class="body_content">
                <div class="body_con">
                    <div class="body_title">封面：</div>
                    <img :src="img_url + '/storage/' + list.pic" style="width: 300px;margin-left: 20px">
                    <div class="body_title">名称：</div>
                    <div class="content_ycx">{{list.title}}</div>
                    <div class="body_title">金额：</div>
                    <div class="content_ycx">{{list.price}}</div>
                    <div class="body_title">内容：</div>
                    <div class="content_ycx" v-html="wenzhang_neirong"></div>
                    <div class="body_title1">发布者：
                        <span class="content_ycx1">{{list.shop.shop_name}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import head from "../../common/head";
    // import {CodeToText} from "element-china-area-data";

    export default {
        name: "video_details",
        data(){
            return{
                img_url:'',
                list:'',
                shop_id:'',//店铺id
                data_info:'',
                xiontai:'',//关注
                input3:'',
                select: '在线服务',
                wenzhang_neirong:'',//仪才秀文章内容
            }
        },
        methods:{
            init(){
                this.img_url = window.config.api_url;
                this.list_data();
            },
            list_data() {
                let t = this;
                let url = window.config.api_url + '/college/video/' + t.$route.params.id;
                t.axios.get(url).then(res => {
                    t.list = res.data.info;
                    t.shop_id = JSON.parse(t.list.shop_id);
                    let html_content = res.data.info.description;
                    html_content = html_content.replace(/(<img .*?src=)"\/(.*?)"/g, '$1"' + window.config.yihai_site + '/$2"');
                    html_content = html_content.replace(/(<source .*?src=)"\/(.*?)"/g, '$1"' + window.config.api_url + '/$2"');
                    html_content = html_content.replace(/(<video .*?src=)"\/(.*?)"/g, '$1"' + window.config.api_url + '/$2"');
                    t.wenzhang_neirong = html_content;
                    t.dp_inform();
                    t.guanzhu();
                })
            },
            dp_inform() {
                let t = this;
                let url = window.config.api_url + '/college/shop/info?id=' + t.shop_id;
                t.axios.get(url).then(res => {
                    t.data_info = res.data;
                })
            },
            guanzhu() {
                let t = this;
                let aid = localStorage.getItem('token');
                let url = window.config.api_url + '/user/shop/focus/check/' + t.shop_id + '?token=' + aid;
                t.axios.get(url).then(res => {
                    t.xiontai = res.data.focus == 1 ? '已关注' : '关注'
                })
            },
            shouce1() {
                let t = this;
                let aid = localStorage.getItem("uid");
                let formData = new FormData();
                formData.append('token', aid);
                formData.append('shop_id', this.shop_id);
                if (t.xiontai == '关注') {
                    let url = window.config.api_url + '/user/shop/focus';
                    t.axios.post(url, formData).then(res => {
                        t.$code(res.data.status);
                        if (res.data.status == 0) {
                            t.open2('成功');
                            this.$router.go(0);
                        }
                        if (res.data.status != 0) {
                            t.open3(res.data.description)
                        }
                    })
                    this.xiontai = '已关注'
                } else {
                    let url1 = window.config.api_url + '/user/shop/unfocus';
                    t.axios.post(url1, formData).then(res => {
                        t.$code(res.data.status);
                        if (res.data.status == 0) {
                            t.open2('成功');
                            this.$router.go(0);
                        }
                        if (res.data.status != 0) {
                            t.open3(res.data.description)
                        }
                    });
                    this.xiontai = '关注'
                }
            },
            shijian() {
                let t = this;
                if (t.input3) {
                    t.$store.commit('shopsSearchValue', t.input3)
                }
                window.location = t.select + this.shop_id
            },
        },
        components:{
            'head_dianpu':head,
        },
        created() {
            this.init();
        }
    }
</script>

<style lang="less" scoped>
    .body_content{
        display: flex;
        justify-content: space-around;
        min-height: 800px;
        overflow: hidden;

        .body_con{
            border-radius: 15px;
            width: 50%;
            margin-top: 10px;
            padding: 20px;

            .body_title{
                font-size: 15px;
                font-family: Source Han Sans CN;
                font-weight: bolder;
                margin-top: 10px;
            }

            .content_ycx{
                margin-left: 20px;
                font-family: Source Han Sans CN;
            }

            .body_title1{
                height: 25px;
                font-size: 22px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                line-height: 80px;
                margin-top: 50px;
            }

            .content_ycx1{
                height: 25px;
                font-size: 22px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #4E6EF2;
                line-height: 80px;
            }
        }
    }
</style>